import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import TopicsList from "@/pages/topics/page";
import TopicDetail from "@/pages/topicDetail/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "topics", element: <TopicsList /> },
      { path: "topic/:id", element: <TopicDetail /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;